import * as React from 'react';
import { Button, ButtonProps } from './button';

export const ButtonPrimary = (props: ButtonProps) => {
  const { children, ...rest } = props;
  return (
    <Button btnType="btn-primary" {...rest}>
      {children}
    </Button>
  );
};
